import React, { useEffect, useState, useContext } from 'react';
import Loading from '@svb/api-loading-component/dist/components';
import { SVBAPIsSection } from '@svb/portal-ui-react-components';
import { getSolutionDetailApisInvolved } from './helper';
import { detailsContext } from './context/DetailsProvider';
import useFilteredCatalogLatestVersion from '../../helpers/utilityCustomHooks/useFilteredCatalogLatestVersion';
import { buildCardJsonForAPis } from '../../helpers/utilityFunctions';
const SolutionDetailsApisInvolved = ({ title, ...props }) => {
  const [loading, setLoading] = useState(true);
  // const [isContent, setIsContent] = useState(false);
  const { addTitle, idGenerator } = useContext(detailsContext);
  const imgbg_slogan = { backgroundImage: "url('/solutions-blue.png')" };
  const filteredCatalogLatestVersion = useFilteredCatalogLatestVersion();
  const solutionCardJson = getSolutionDetailApisInvolved(
    props.url,
    props.solType,
    filteredCatalogLatestVersion,
  );

  const getFinalAPiInvolvedData = buildCardJsonForAPis(solutionCardJson.response);
  useEffect(() => {
    addTitle(title);
  }, [title]);

  useEffect(() => {
    setLoading(false);
  }, [getFinalAPiInvolvedData]);
  if (loading) {
    return <Loading />;
  }
  const LearnMoreCardLabel = () => (
    <span className='learn-more-label'>
      {'Learn More'}
      <i className='fa-solid fa-arrow-right right-arrow-icon' />
    </span>
  );
  const apiCardsData = {
    apiSectionlabel: title, //title for molecule
    apisJson: getFinalAPiInvolvedData.response, //json from service
    cardsOption: {
      extraClasses: 'solution-details-cards',
      cardOptions: {
        extraClasses: 'solution-details-api-card',
        overrideLearnMoreElement: LearnMoreCardLabel(),
      },
    },
    extraClasses: 'solution-details-api-card',
  };

  return (
    <section className='solution-api-involved-bg-img' style={imgbg_slogan}>
      <div className='solutions_solutionDetails_apis_wrapper ' id={idGenerator(title)}>
        <div className='row'>
          <div className='homepage_hero__Subseparation'></div>
        </div>
        {getFinalAPiInvolvedData.response.length > 0 && (
          <SVBAPIsSection apiCardsData={apiCardsData} />
        )}
      </div>
    </section>
  );
};

export default SolutionDetailsApisInvolved;
